import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ChatUploadedFileChip from 'llm/chat-library/messages/ChatUploadedFileChip';
import {
  ClientOptimisticUserMessage,
  DisplayMessageChatEventNode,
} from 'llm/chat-library/messages/MessageTypes';
import {assertNever} from 'util/Types';

import {ChatMessageBubble} from './ChatMessageBubble';

export interface ChatUserMessageBubbleProps {
  event: DisplayMessageChatEventNode | ClientOptimisticUserMessage;
  chatSessionId: string | null;
}

const ChatUserMessageBubble = React.forwardRef<HTMLDivElement, ChatUserMessageBubbleProps>(
  ({event, chatSessionId}, ref): JSX.Element => (
    <ChatMessageBubble ref={ref} variant="user_message" toolbar={null}>
      {event.messageBlocks.flatMap((block, index) => {
        switch (block.__typename) {
          case 'DisplayTextBlockNode': {
            return [
              <div
                key={index}
                {...getTestProps({
                  component: 'ChatUserMessageBubble',
                  element: 'text',
                })}
              >
                {block.text}
              </div>,
            ];
          }
          case 'DisplayFileBlockNode': {
            return [
              <div key={index} className={css(styles.chipContainer)}>
                <ChatUploadedFileChip
                  chatSessionId={chatSessionId}
                  // See: createPendingUserMessage. It produces a ClientOptimisticUserMessage,
                  // where the externalFileId is not set.
                  // eslint-disable-next-line benchlint/no-in-operator
                  externalFileId={'externalFileId' in block ? block.externalFileId : null}
                  filename={block.filename}
                  mediaType={block.mediaType}
                />
              </div>,
            ];
          }
          default: {
            assertNever(block);
            return [];
          }
        }
      })}
    </ChatMessageBubble>
  )
);

export default ChatUserMessageBubble;

const styles = StyleSheet.create({
  chipContainer: {
    marginTop: '8px',
  },
});
